<template>
  <b-row v-if="isSomeCriteriaSet">
    <template v-for="componentData in componentsData">
      <b-col :key="componentData.key">
        <component :is="componentData.name" v-bind="componentData.props" />
      </b-col>
      <b-col v-if="componentData.subName" :key="componentData.key + 's'">
        <component :is="componentData.subName" v-bind="componentData.props" />
      </b-col>
    </template>
  </b-row>
</template>

<script>
import { JOB_QUESTION_TYPES } from '@/store';
import RecruiterIcoCriteriaResultLocation from '@/components/recruiter/ico/criteria/result/RecruiterIcoCriteriaResultLocation';
import RecruiterIcoCriteriaResultJobQuestion from '@/components/recruiter/ico/criteria/result/RecruiterIcoCriteriaResultJobQuestion';
import PrePaywallIcoBrowserCriteriaResultSpecialty from '@/components/pre-paywall-pages/recruiter/PrePaywallIcoBrowserCriteriaResultSpecialty';
import PrePaywallIcoBrowserCriteriaResultSubspecialty from '@/components/pre-paywall-pages/recruiter/PrePaywallIcoBrowserCriteriaResultSubspecialty';
export default {
  name: 'PrePaywallIcoBrowserCriteriaResults',
  components: {
    RecruiterIcoCriteriaResultJobQuestion,
    RecruiterIcoCriteriaResultLocation,
    PrePaywallIcoBrowserCriteriaResultSpecialty,
    PrePaywallIcoBrowserCriteriaResultSubspecialty,
  },
  props: {
    criteriaItems: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  computed: {
    isSomeCriteriaSet: function () {
      return this.componentsData.some((i) => i.isVisible);
    },
    componentsData: function () {
      return this.criteriaItems.reduce((data, item) => {
        if (!item.value) return data;
        switch (item.talent_type) {
          case JOB_QUESTION_TYPES.LOCATION:
            if (Object.keys(item.value).length && item.value.value) {
              data.push({
                name: RecruiterIcoCriteriaResultLocation.name,
                key: item.id,
                props: {
                  jobQuestion: item,
                },
                isVisible: !!item.value,
              });
            }
            break;
          case JOB_QUESTION_TYPES.SPECIALTY:
            if (
              !Object.keys(item.value).length ||
              !(item.value.specialtyId || item.value.subspecialtyId)
            )
              return data;
            data.push({
              name: PrePaywallIcoBrowserCriteriaResultSpecialty.name,
              subName: PrePaywallIcoBrowserCriteriaResultSubspecialty.name,
              key: item.id,
              props: {
                jobQuestion: item,
              },
              isVisible: !!item.value,
            });
            break;
          default:
            if (
              !(Array.isArray(item.value) && item.value.length) &&
              !Object.keys(item.value).length
            )
              return data;
            data.push({
              name: RecruiterIcoCriteriaResultJobQuestion.name,
              key: item.id,
              props: {
                jobQuestion: item,
              },
              isVisible:
                item.value &&
                ((Array.isArray(item.value) && item.value.length) ||
                  Object.keys(item.value).length),
            });
        }
        return data;
      }, []);
    },
  },
};
</script>

<style scoped />
